/* eslint-disable max-classes-per-file */
import * as d3 from 'd3'

import { appSettings } from 'bam-node-baseball-savant/leaderboard/appSettings'
import Chart, {
    createKey,
} from 'bam-node-baseball-savant/visuals/bat-speed-distribution'

import 'bam-node-baseball-savant/leaderboard/utils/multi-select'

const $vizWrapper = d3.select('#viz-container')

const currentYear = appSettings.batTracking.year

const separator = '|'

// Initialize
const urlSearchParams = new URLSearchParams(window.location.search)

const chart = new Chart($vizWrapper, [], {
    legend: { editable: true },
})

function changeListener() {
    // const playerIds = chart.data.map((d) => d.playerId)
    // const { lockScale, prop, scaleType } = chart
    // const url = new URL(window.location)
    // url.searchParams.set('playerIds', playerIds.join(separator))
    // url.searchParams.set('lockScale', lockScale ? 1 : 0)
    // url.searchParams.set('scaleType', scaleType)
    // url.searchParams.set('yAxis', prop)
    // window.history.replaceState('', '', url.toString())
}

function butcherName(displayLastFirst) {
    const [last, first] = displayLastFirst.split(', ')

    if (!last || !first) {
        return displayLastFirst
    }

    return `${first.slice(0, 1)}. ${last}`
}

const propertyOptions = new Set([
    'swings',
    'contact',
    'bbe',
    'hard_hit',
    'swings_percent',
    'contact_percent',
    'bbe_percent',
    'hard_hit_percent',
])

const playerIds = urlSearchParams.get('playerIds') || '' // string or null
const yearsRaw = urlSearchParams.get('years') || ''
const sidesRaw = urlSearchParams.get('sides') || ''
const playerTypesRaw = urlSearchParams.get('playerTypes') || ''

const initialOptions = [
    { playerId: 592450, year: currentYear, side: 'R', playerType: 'batter' }, // Judge
    { playerId: 605141, year: currentYear, side: 'R', playerType: 'batter' }, // Betts
    { playerId: 665489, year: currentYear, side: 'R', playerType: 'batter' }, // Vlad
    { playerId: 650333, year: currentYear, side: 'L', playerType: 'batter' }, // Arraez
    { playerId: 660271, year: currentYear, side: 'L', playerType: 'batter' }, // Ohtani
    { playerId: 682829, year: currentYear, side: '', playerType: 'batter' }, // EDLC
]

const randomIdx = Math.floor(Math.random() * initialOptions.length)
const randomPlayer = initialOptions[randomIdx]

const isRandom = Boolean(!playerIds)
// number[]
// TODO!
const ids = playerIds
    ? playerIds
          ?.split(separator)
          .map((d) => Number(d.trim()))
          .filter((d) => d && !Number.isNaN(d))
    : [randomPlayer.playerId]

const years = playerIds ? yearsRaw.split(separator) : [randomPlayer.year]

const sides = playerIds ? sidesRaw.split(separator) : [randomPlayer.side]

const playerTypes = playerIds
    ? playerTypesRaw.split(separator)
    : [randomPlayer.playerType]

function init() {
    // Handle scale type
    const isPercentScale = urlSearchParams.get('scaleType') !== 'raw'
    const scale = isPercentScale ? 'percent' : 'raw'
    chart.updateScaleType(scale)

    // Handle yAxis property
    // eslint-disable-next-line no-nested-ternary
    const yAxis = propertyOptions.has(urlSearchParams.get('yAxis'))
        ? urlSearchParams.get('yAxis')
        : isPercentScale
        ? 'swings_percent'
        : 'swings'

    chart.updateProp(yAxis)

    // Handle lock scale
    const lockScale = urlSearchParams.get('lockScale') !== '0'
    chart.updateLock(lockScale)

    const leaguePromise = fetchLeagueDistribution()

    Promise.allSettled(
        ids.map((id, i) =>
            fetchPlayerData(
                id,
                years[i] || currentYear,
                sides[i],
                playerTypes[i]
            )
        )
    )
        .then((settledPromises) =>
            settledPromises
                .filter(
                    ({ status, value }) =>
                        status === 'fulfilled' &&
                        Object.keys(value?.data || {}).length
                )
                .map(({ value }) => value)
        )
        .then((dataArr) => {
            dataArr.forEach(({ data, player }, i) => {
                data.forEach((d) => {
                    const playerId = ids[i]
                    const { side, year } = d
                    const playerType = playerTypes[i] || 'batter'
                    const title = butcherName(player.name_display_last_first)
                    const key = createKey(playerId, year, side, playerType)

                    chart.addCurve({ key, playerId, title, playerType }, d)
                })
            })
            if (!isRandom) {
                chart.updateUrl()
            }
            chart.subscribe(changeListener)
        })
        .then(() => {
            leaguePromise.then(({ data }) => {
                chart.addDashed(
                    {
                        key: `league-${currentYear}`,
                        playerId: 'league',
                        title: 'League',
                    },
                    data[0],
                    true
                )
            })
        })
        .catch(console.error)
}

function fetchPlayerData(playerId, year, handedness, playerType) {
    return fetch(
        `/visuals/bat-speed-distribution/${playerId}?type=${playerType}&seasonStart=${year}&seasonEnd=${year}&side=${handedness}`
    ).then((res) => res.json())
}

function fetchLeagueDistribution() {
    return fetch(`/visuals/bat-speed-distribution-league/${currentYear}`).then(
        (res) => res.json()
    )
}

init()

// Autocomplete logic - Some work to be done to make this typescriptable
const ac = document.querySelector(
    'auto-complete#bat-speed-distribution-player-search'
)

ac.renderItem = (item, i) => {
    let handedness = 'Switch'
    if (item.side === 'L') {
        handedness = 'Left Handed'
    } else if (item.side === 'R') {
        handedness = 'Right Handed'
    }
    return `
    <li role="option" data-idx="${i}" aria-selected="false">
        <span class="savant-autocomplete">
            <div>
                <img src="https://content.mlb.com/images/headshots/current/60x60/${item.player_id}.png" height="30" width="30" />
                ${item.name}
            </div>
            <span style="font-size: 0.7rem">
                (${item.year} - ${handedness} ${item.player_type})
            </span>
        </span>
    </li>
    `
}

// listen for selection
ac.addEventListener('select', (e) => {
    const { player_id, year, side, player_type } = e.detail.item
    fetchPlayerData(player_id, year, side, player_type)
        .then(({ player, data }) => {
            data.forEach((d) => {
                const title = butcherName(player.name_display_last_first)
                const key = createKey(player_id, year, side, player_type)
                chart.addCurve(
                    {
                        playerId: player_id,
                        key,
                        title,
                        playerType: player_type,
                    },
                    d
                )
            })
            if (data.length) {
                chart.updateUrl()
            }
        })
        .catch((err) => {
            console.error(err)
        })
})
